import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "gui-common/redux/store";
import {Button, Grid, Header, Input, Modal, ProgressBar, styles, Surface, Text, useTheme} from "tmwx-design-web/src";
import {useTranslation} from "react-i18next";
import {isEmpty} from "gui-common/appHelper";
import {usePermissions} from "tmwx-design-common";
import {Code} from "gui-common/redux/data/pythonScript";
import {getCodeList} from "gui-common/redux/action/efe/pythonScriptAction";
import {pythonScriptActions} from "gui-common/redux/slice/efe/pythonScriptSlice";

function ModalRow({code, handleOnClick}: { code: Code, handleOnClick: (code: Code) => void }) {
    const {roundness, padding, colors} = useTheme()
    const {t} = useTranslation();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className={'row'} style={{
            ...styles.row, ...styles.justifyContent_spaceBetween,
            ...{padding: padding},
            alignItems: 'center'
        }} onClick={() => handleOnClick(code)}>
            {/*<Icon name={'remove'}/>*/}

            <Text bold>
                {code.ptcPyCodeName}
            </Text>

            <Text>
                {code.ptcPyCodeTag}
            </Text>

            <Button
                size="small"
                variant="contained"
                onPress={() => handleOnClick(code)}
            >
                {t('select')}
            </Button>

            <style>
                {`
                .row {
                background-color: ${colors.elevation.level0};
            }

                .row:hover {
                background-color: ${colors.elevation.level1};
                cursor:pointer;
            }
                `}
            </style>
        </div>

    );
}

const CodeSearchModal = ({label}: { label: string }) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const { hasRights } = usePermissions()

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);
    const [search, setSearch] = useState<string>('')

    const loading = useSelector<RootState, boolean>(state => state.pythonScript.loading);
    const codeList = useSelector<RootState, Code[]>(state => state.pythonScript.codeList);

    useEffect(() => {
        if (hasRights(["efe_python_script_view"])) {
            dispatch(getCodeList());
        }
    }, [dispatch]);

    const handleOnClick = (selectedCode: Code) => {
        dispatch(pythonScriptActions.setSelectedCode(selectedCode))
        handleClose()
    }

    const handleClose = () => {
        setIsDialogOpen(false);
    };

    const handleDialogOpen = () => {
        setIsDialogOpen(true);
    };

    return (
        <Surface style={{marginBottom: 4, marginLeft: 4, marginRight: 4, width: '100%'}}>
            <div onClick={handleDialogOpen}>
                <Input
                    style={{ml: 1, fontWeight: 500}}
                    fullWidth
                    placeholder={t('efe.codeSearch')}
                    value={label}
                />
            </div>

            <Modal
                visible={isDialogOpen}
                type='dialog'
                dialogMaxWidth='m'
                contentElevation={0}
                closeModal={handleClose}
                header={(
                    <Header
                        title={t('efe.codeSearch')}
                        actionRight={<Button iconLeft={'clear'} status='neutral' variant='ghost'
                                             onPress={handleClose}/>}
                    />
                )}
            >
                <Surface elevation={0}>
                    <Grid.Container centered maxWidth="xl">
                        <Grid.Col m={12} lg={12} xl={12}>
                            <Input
                                style={{ml: 1, fontWeight: 500}}
                                fullWidth
                                icon={"search"}
                                placeholder={t('efe.codeSearch')}
                                value={search}
                                onChangeValue={(text) => setSearch(text)}
                            />
                        </Grid.Col>

                        <Grid.Col m={12} lg={12} xl={12}>

                            {(loading || isEmpty(codeList)) ? (
                                <ProgressBar animated rounded={false} width={'100%'} height={6} vertical={false}/>
                            ) : (
                                codeList.filter((val) => {
                                    if (isEmpty(search)) {
                                        return val;
                                    } else if (val.ptcPyCodeTag.toLocaleLowerCase().includes(search.toLocaleLowerCase())) {
                                        return val;
                                    }
                                }).map((item, index) => {
                                    return (
                                        <ModalRow key={index} code={item} handleOnClick={() => handleOnClick(item)}/>
                                    );
                                })
                            )}
                        </Grid.Col>
                    </Grid.Container>
                </Surface>
            </Modal>
        </Surface>
    )
}

export default CodeSearchModal;